
import { Component, Mixins } from "vue-property-decorator";
import { default as StyledTextEditableObjectMixin } from "./StyledTextEditableObjectMixin.vue";
import { default as OptionSelectableMixin } from "./OptionSelectableMixin.vue";

@Component({
})
export default class OptionSelectableStyledTextEditableObjectMixin extends Mixins(
  StyledTextEditableObjectMixin,
  OptionSelectableMixin
) {
}
